export default "__VITE_ASSET__CB_Hx_Tr__"